'use strict';

export default {
  discountCodes: {
    labels: {
      discountCodes: 'Codes rabais',
      code: 'Code',
      quantity: 'Qté',
      expirationDate: "Date d'expiration",
      discount: 'Rabais',
    },
    errors: {
      invalidExpirationDate: "La date d'expiration est invalide",
      codeRequired: 'Le code est requis',
      quantityInvalid: 'La quantité doit être un nombre valide plus grand que 0',
      discountMin: 'Le rabais doit être plus grand ou égal à 0',
      discountMax: 'Le rabais doit être plus petit ou égal à 100%',
      discountValueRequired: 'La valeur du rabais est requise',
    },
  },
};
